import { Star, ArrowUpRight } from "lucide-react";
import Text from "../Text";
import Img from "../Img";
import { getImg } from "../../../../Components/Utils";

const ReviewCard = ({ review }) => (
  <div className="flex flex-col sm:flex-row gap-4 bg-white rounded-2xl p-4 shadow-sm border border-gray-100">
    {/* Product image — hidden on mobile */}
    <div className="hidden sm:block flex-shrink-0 w-[240px] aspect-[243/309] rounded-xl overflow-hidden">
      <Img
        src={getImg(review.images?.[0]??'')}
        alt={review.productTitle}
        className="w-full h-full object-cover"
      />
    </div>

    {/* Content */}
    <div className="flex-1 flex flex-col gap-2 min-w-0">
      {/* Stars */}
      <div className="flex items-center gap-0.5">
        {Array.from({ length: 5 }).map((_, i) => (
          <Star
            key={i}
            size={14}
            className={
              i < review.rating
                ? "fill-blue-500 text-blue-500"
                : "fill-gray-200 text-gray-200"
            }
          />
        ))}
      </div>

      {/* Review text */}
      <Text
        is="p"
        variant="body"
        className="text-gray-700 leading-relaxed line-clamp-3"
      >
        {review.text}
      </Text>

      {/* Reviewer */}
      <div>
        <Text
          is="p"
          variant="body"
          className="text-gray-900 font-semibold text-sm"
        >
          {review.name}
        </Text>
        <Text is="p" variant="label" className="text-gray-400">
          {review.location}
        </Text>
      </div>

      {/* Product snippet */}
      <div className="flex items-center gap-3 mt-auto pt-2 border-t border-gray-100">
        <div className="w-[63px] aspect-[63/81] rounded-lg overflow-hidden flex-shrink-0">
          <Img
            src={getImg(review.images?.[1]??review.images?.[0]??'')}
            alt={review.productTitle}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="flex-1 min-w-0">
          <Text is="p" variant="label" className="text-gray-500 truncate">
            {review.location}
          </Text>
          <div className="flex items-center gap-1.5">
            {review.originalPrice && (
              <Text
                is="span"
                variant="body"
                className="text-gray-400 line-through text-xs"
              >
                {review.originalPrice}
              </Text>
            )}
            <Text
              is="span"
              variant="body"
              className="text-blue-500 font-semibold text-sm"
            >
              {review.salePrice}
            </Text>
          </div>
        </div>
        <button aria-label="View product" className="w-8 h-8 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-50 transition-colors flex-shrink-0">
          <ArrowUpRight size={14} className="text-gray-600" />
        </button>
      </div>
    </div>
  </div>
);

export default ReviewCard;
